import Vue from "vue";
import Vuex from "vuex";
import courses from "@/store/models/hr/courses.js";
import employees from "@/store/models/hr/employees.js";
import departments from "@/store/models/hr/departments";
import jobs from "@/store/models/hr/jobs";
import cities from "@/store/models/location/cities";
import countries from "@/store/models/location/countries";
import employeeReviews from "@/store/models/hr/employeeReviews";
import trainingHistory from "@/store/models/hr/trainingHistory";
import coursesDomains from "@/store/models/hr/coursesDomains";
import jobHistory from "@/store/models/hr/jobHistory";
import loader from "@/store/models/loader";
import page from "@/store/models/page";
import location from "@/store/models/location/location";
import users from "@/store/models/users/users";
import leaves from "@/store/models/leaves/leaves";
import skills from "@/store/models/hr/skills";
import skillsLevels from "@/store/models/hr/skillsLevels";
import employeeAttendences from "@/store/models/attendance/employeeAttendences";
import holidays from "@/store/models/attendance/holidays";
import auth from "@/store/models/auth/auth";
import shifts from "@/store/models/attendance/Shifts";
import attendenceTemplates from "@/store/models/attendance/attendenceTemplates";
import leaveTypes from "@/store/models/settings/leavesTypes";
import projects from "@/store/models/taskManager/projects";
import tasks from "@/store/models/taskManager/tasks";
import employeesShifts from "@/store/models/attendance/employeesShifts";
import rbtypes from "@/store/models/rollPay/employeeRbtypes";
import settings from "./models/projectSettings/settings";
import salaries from "./models/rollPay/salaries";
import paidWage from "@/store/models/rollPay/paidWage";
import employeeWages from "@/store/models/rollPay/employeeWages";
import rolesAndPermissions from "./models/users/rolesAndPermissions";
import diroctrates from "./models/directorates/diroctrates";
import settingsCountries from "./models/settings/countries-module";
import settingsCities from "./models/settings/cities-module";
import taxs from "@/store/models/rollPay/taxSlices";
import rules from "@/store/models/settings/rules";
import conditions from "@/store/models/settings/conditions";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    employees,
    courses,
    departments,
    jobs,
    cities,
    employeeReviews,
    trainingHistory,
    coursesDomains,
    jobHistory,
    loader,
    location,
    skills,
    skillsLevels,
    page,
    employeeAttendences,
    holidays,
    countries,
    auth,
    shifts,
    attendenceTemplates,
    users,
    leaves,
    leaveTypes,
    projects,
    tasks,
    employeesShifts,
    rbtypes,
    settings,
    salaries,
    paidWage,
    employeeWages,
    rolesAndPermissions,
    diroctrates,
    settingsCountries,
    settingsCities,
    taxs,
    rules,
    conditions,
  },
});
